import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import moment from 'moment';
import { lastValueFrom } from 'rxjs';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from 'src/app/pages/product-detail-updated/product-detail-updated.module';
import { MGetProductRequest, MGetProductResponse } from 'src/app/pages/product/product.module';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { Services, SharedPrefrences } from 'src/app/utils/utils.service';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';

@Component({
  selector: 'app-paymentstatus',
  templateUrl: './paymentstatus.component.html',
  styleUrls: ['./paymentstatus.component.scss']
})

export class PaymentstatusComponent {
  paymentSuccess!: boolean;
  userId: any;
  orderDetail: any;
  qty: number = 0;
  totalAmount: number = 0;
  totalAmountWithTaxDiscount: any = 0;
  blogList: any = [];
  trendingBlogs: any = [];
  allTrendingBlogsCategoryWise: any;
  mGetProductRequest: MGetProductRequest = new MGetProductRequest()
  alltags: any = [];
  tagsProducts: any = [];
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  mGetProductResponse: MGetProductResponse = new MGetProductResponse()
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mWishlistData: any = [];
  showfoyfavLeftArrow: boolean = true;
  showfoyfavRightArrow: boolean = true;
  @ViewChild('foyfav') foyfav!: ElementRef;
  constructor(private services:Services ,private _commonBehaviorChangeService: CommonBehaviorChangeService,private wsblogservice: WsBlogService,private activatedRoute: ActivatedRoute, private router: Router, private wsShopAllService: WsShopallService, private wsUserProfileService: WsUserProfileService) {
    this.getOrderList();
    this.getTrendingBlogList();
    this.getAllTag()
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
     
      this.tagsProducts && this.tagsProducts.length > 0 && this.tagsProducts.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product.cartQty = cartPresent[0].qty;
        }
        else {
          delete product.cartQty;
        }
      })
    })

    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
    })

    if(this.router.url.indexOf('cod') != -1){
      this.paymentSuccess = true;
       
      if (localStorage.getItem('orderType') == 'cart') {
         this.removeCartItems();
       }
          localStorage.setItem("buynow", '')
          localStorage.setItem("discountCode", '')
          localStorage.setItem("addressSelected", '')
          localStorage.setItem('orderType', 'order')
    }else{

      this.activatedRoute.queryParams.subscribe(async (params: Params) => {
        if(this.router.url.indexOf('paymentstatus') != -1 ){
        if (params && params['status'] == 'CHARGED') { 
          this.paymentSuccess = true;
          
          if (localStorage.getItem('orderType') == 'cart') {
           await this.removeCartItems();
          }
              localStorage.setItem("buynow", '')
              localStorage.setItem('orderType', 'order')
              localStorage.setItem("discountCode", '')
              localStorage.setItem("addressSelected", '')
          
        } else {
          this.paymentSuccess = false;
          this.tryAgain();
        }
      }
      });
    }
  }

  tryAgain(){
    var discountCode = localStorage.getItem("discountCode")
    if (localStorage.getItem('orderType') == 'cart') {
      const userAgent = window.navigator.userAgent.toLowerCase();
      var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
      if(discountCode){
        if(mobile){
          this.router.navigate(["/checkout-new-mob/cart/" +  discountCode])
        }else{
          this.router.navigate(["/checkout-new/cart/" +  discountCode])
        }
      }else{
        if(mobile){
          this.router.navigate(["/checkout-new-mob/cart"])
        }else{
          this.router.navigate(["/checkout-new/cart"])
        }
      }
    } else if (localStorage.getItem('orderType') == 'buynow') {
      const userAgent = window.navigator.userAgent.toLowerCase(); 
      var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
      if(discountCode){
        if(mobile){
          this.router.navigate(["/checkout-new-mob/buynow/"+ "" + localStorage.getItem('productId') + '/' + discountCode])
        }else{
          this.router.navigate(["/checkout-new/buynow/"+ "" + localStorage.getItem('productId') +  '/' + discountCode])
        }
      }else{
        if(mobile){
          this.router.navigate(["/checkout-new-mob/buynow/"+ "" + localStorage.getItem('productId')])
        }else{
          this.router.navigate(["/checkout-new/buynow/"+ "" + localStorage.getItem('productId')])
        }
      }
    }
  }

  /**
  * Date: 10-06-23
  * Method : This method is used to remove all cart items 
  */
  async removeCartItems() {
    const removeCartList = this.wsShopAllService.removeCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(removeCartList).then(async response => {
      if (response && response.statusCode == 200) {
        this._commonBehaviorChangeService.addCart(true);
      }
    })
  }

  getOrderList() {
    this.userId = SharedPrefrences.getUserId();
    const orderRequest = {
      take: 1,
      skip: 0,
      search : "odr.user_id = '" + this.userId + "'"
    }
    this.getOrderDetaiList(orderRequest);
  }

  async getOrderDetaiList(search: any) {
    const orderList = this.wsUserProfileService.getOrderDetailList(search)
    await lastValueFrom(orderList).then(async response => {
      if (response && response.statusCode == 200) {
        this.orderDetail = response.data[0]
        this.qty = 0;
        await this.orderDetail.product_detail.forEach((product:any) => {
          this.qty = this.qty + product.product_qty;
          this.totalAmount = this.totalAmount + (product.product_price * product.product_qty)
        })

        this.totalAmountWithTaxDiscount = this.totalAmount - this.orderDetail.total_discount_amount + this.orderDetail.total_tax + this.orderDetail.shipping_charge;
      }
    })
  }

  async getTrendingBlogList() {
    this.trendingBlogs = [];
    const trendingBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(true);
    await lastValueFrom(trendingBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        this.allTrendingBlogsCategoryWise = response.data;
        response.data.forEach((blog:any) => {
          if(this.trendingBlogs.length < 1){
            this.trendingBlogs = blog.blogs;
          }else{
            this.trendingBlogs = [...this.trendingBlogs , ...blog.blogs];
          }
        })
      }
    })
  }

  getBlogThumbnail(imageList: any) {
    if (imageList.length < 1) {
      return 'assets/images/noblogimage.jpg'
    }
    var thumbnail = imageList.filter((img: any) => img.type == 'blog_thumbnail_image')
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return 'assets/images/noblogimage.jpg'
    }
  }

  async getFavouritesProducts() {
    this.mGetProductRequest = new MGetProductRequest();
    const favoritesTag = this.alltags.find((tag: any) => tag.title.toLowerCase() === 'FOY FAVOURITES'.toLowerCase());
    if (favoritesTag) {
      this.mGetProductRequest.tags = favoritesTag.id.toString();
    } else {
      this.mGetProductRequest.tags = '';
      return;
    }
    const getAllProductByTags = this.wsShopAllService.getAllProductByTags(this.mGetProductRequest.tags)
    await lastValueFrom(getAllProductByTags).then(async response => {
      this.mGetProductResponse.totalRecords = response.totalRecords;
      this.tagsProducts = []
      if (this.tagsProducts && this.tagsProducts.length < 1) {
        this.tagsProducts = response.data.slice(0, 12);
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          this.tagsProducts.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent.length > 0) {
              product.cartQty = cartPresent[0].qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          this.tagsProducts.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
      } else {
        if (this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0) {
          response.data.forEach((product: any) => {
            const cartPresent = this.mAddUpdateCartModuleResponse.data.findIndex(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (cartPresent > -1) {
              product.cartQty = cartPresent.qty;
            }
          })
        }
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          response.data.forEach((product: any) => {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === product.id && el.qty > 0) });
            if (present) {
              product.like = true;
            }
          })
        }
        this.tagsProducts = [...this.tagsProducts, ...response.data];
      }
    })
  }

  async getAllTag() {
    const getAllTag = this.wsShopAllService.getAllTags()
    await lastValueFrom(getAllTag).then(async response => {
      if (response && response.statusCode == 200) {
        this.alltags = response.data;
        this.getFavouritesProducts()
      }
    })
  }

  setDateFormat(date: any) {
    return moment(new Date(date)).format('hh:mm a, DD/MM/YY')
  }

  viewOrderDetails(){
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if(mobile){
      this.router.navigate(["/user-my-orders/" + this.orderDetail.id])
    }else{
      const data = {orderId: this.orderDetail.id}
      this.services.orderListEvent.emit(true)
      this.router.navigate(['/user/' + SharedPrefrences.getUserId()],{state: data})
    }
   
  }

  async openBlogDetail(val: any) {
    this.router.navigate(["/individual-blog-updated/"+val.title.split(' ').join('_')+'/'+val.category_id+'/'+val.id])
  }

  checkAllArrow() { 
    if (this.foyfav) {
      let foyfavcontainer = this.foyfav.nativeElement;
      this.showfoyfavLeftArrow = foyfavcontainer .scrollLeft > 0;
      this.showfoyfavRightArrow = foyfavcontainer .scrollWidth > foyfavcontainer .clientWidth + foyfavcontainer .scrollLeft;
    }
  }
  checkScroll(id: any) {
    switch (id) {
      case 'foyfav':
        let foyfavcontainer = this.foyfav.nativeElement;
        this.showfoyfavLeftArrow = foyfavcontainer .scrollLeft > 0;
        this.showfoyfavRightArrow = foyfavcontainer .scrollWidth > foyfavcontainer .clientWidth + foyfavcontainer .scrollLeft;
        break;
    }
  }

  goLeft(id: any) {
    var container = document.getElementById(id)
    if (container) {
      this.sideScroll(container, 'left', 10, 200, 10);
      setTimeout(() => {
        this.checkScroll(id)
      }, 1000);
    }
  }
  sideScroll(element: any, direction: any, speed: any, distance: any, step: any) {
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  goRight(id: any) {
    var container = document.getElementById(id)
    if (container) {
      this.sideScroll(container, 'right', 10, 200, 10);
      setTimeout(() => {
        this.checkScroll(id)
      }, 1000);
    }
  }
  }